// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { LatencyBand, ILatencyBand } from "./ClientEndpoints.LatencyBand.gen";
import { HealthBucket, IHealthBucket } from "./ClientEndpoints.HealthBucket.gen";
import { OutcomeCount, IOutcomeCount } from "./ClientEndpoints.OutcomeCount.gen";

export interface IClientEndpointHealthWindow {
	windowStartUtc: string | undefined;

	windowEndUtc: string | undefined;

	sends: number;

	failures: number;

	slowSends: number;

	successRate: number | undefined;

	latencyMeasuredSends: number;

	medianMs: ILatencyBand | undefined;

	p95Ms: ILatencyBand | undefined;

	maxMs: number | undefined;

	buckets: IHealthBucket[] | undefined;

	stripStartUtc: string | undefined;

	topFailureOutcomes: IOutcomeCount[] | undefined;

	lastFailureUtc: string | undefined;

	lastFailureMessage: string | undefined;

	extendsBeyondRawHistory: boolean;

	$type?: string | undefined;
}
export class ClientEndpointHealthWindow {
	constructor(data?: IClientEndpointHealthWindow) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.windowStartUtc) { this.windowStartUtc = new Date(data.windowStartUtc); }
		if (data.windowEndUtc) { this.windowEndUtc = new Date(data.windowEndUtc); }
		if (data.medianMs) { this.medianMs = new LatencyBand(data.medianMs); }
		if (data.p95Ms) { this.p95Ms = new LatencyBand(data.p95Ms); }
		this.buckets = data.buckets ? data.buckets.map((b: any) => new HealthBucket(b)) : [];
		if (data.stripStartUtc) { this.stripStartUtc = new Date(data.stripStartUtc); }
		this.topFailureOutcomes = data.topFailureOutcomes ? data.topFailureOutcomes.map((t: any) => new OutcomeCount(t)) : [];
		if (data.lastFailureUtc) { this.lastFailureUtc = new Date(data.lastFailureUtc); }
	}

	windowStartUtc: Date | undefined = new Date();

	windowEndUtc: Date | undefined = new Date();

	sends: number = 0;

	failures: number = 0;

	slowSends: number = 0;

	successRate: number | undefined;

	latencyMeasuredSends: number = 0;

	medianMs: LatencyBand | undefined;

	p95Ms: LatencyBand | undefined;

	maxMs: number | undefined;

	buckets: HealthBucket[] | undefined = [];

	stripStartUtc: Date | undefined = new Date();

	topFailureOutcomes: OutcomeCount[] | undefined = [];

	lastFailureUtc: Date | undefined;

	lastFailureMessage: string | undefined;

	extendsBeyondRawHistory: boolean = false;

	static $type: string = "CoreApi.Models.ClientEndpoints.ClientEndpointHealthWindow, ";
	$type?: string | undefined = ClientEndpointHealthWindow.$type;
}

